import { useQuery } from "@tanstack/react-query";
import { sdk } from "@/config/medusa";
import { handleErrorToast } from "@/utils/helpers";
import { useUser } from "@/context/user";
import storage from "@/utils/storage";
import { Order } from "@/types/order";

const useQueryOrders = (bid?: string) => {
  const isAuthenticated = useUser((state) => state.isAuthenticated);
  const vid = storage.getItem("vid");

  const getOrders = async () => {
    const endpoint = bid
      ? `/vendor/${vid}/brands/${bid}/orders`
      : `/vendor/${vid}/orders`;

    try {
      const data = await sdk.client.fetch<Order[]>(endpoint);
      return data;
    } catch (e) {
      handleErrorToast(e);
    }
  };

  const query = useQuery({
    queryKey: ["orders", vid, bid],
    queryFn: getOrders,
    enabled: isAuthenticated,
  });

  return {
    ...query,
    isFetching: query.isFetching,
  };
};

export default useQueryOrders;
